// Actions
export const setClientes = ({ commit }, payload) => {
  commit('SET_CLIENTES', payload)
}
export const addClientes = ({ commit }, payload) => {
  commit('ADD_CLIENTES', payload)
}
export const setClientesLoading = ({ commit }, payload) => {
  commit('SET_CLIENTES_LOADING', payload)
}

export const setConfig = ({ commit }, payload) => {
  commit('SET_CONFIG', payload)
}
export const addConfig = ({ commit }, payload) => {
  commit('ADD_CONFIG', payload)
}
export const setConfigLoading = ({ commit }, payload) => {
  commit('SET_CONFIG_LOADING', payload)
}

export const setSigners = ({ commit }, payload) => {
  commit('SET_SIGNERS', payload)
}
export const addSigners = ({ commit }, payload) => {
  commit('ADD_SIGNERS', payload)
}
export const setSignersLoading = ({ commit }, payload) => {
  commit('SET_SIGNERS_LOADING', payload)
}

export const setIps = ({ commit }, payload) => {
  commit('SET_IPS', payload)
}
export const setIpsQuestions = ({ commit }, payload) => {
  commit('SET_IPS_QUESTIONS', payload)
}
export const addIps = ({ commit }, payload) => {
  commit('ADD_IPS', payload)
}
export const setIpsLoading = ({ commit }, payload) => {
  commit('SET_IPS_LOADING', payload)
}

export const setForms = ({ commit }, payload) => {
  commit('SET_FORMS', payload)
}
export const addForms = ({ commit }, payload) => {
  commit('ADD_FORMS', payload)
}
export const setFormsLoading = ({ commit }, payload) => {
  commit('SET_FORMS_LOADING', payload)
}

export const setFormsAnswer = ({ commit }, payload) => {
  commit('SET_FORMS_ANSWER', payload)
}
export const addFormsAnswer = ({ commit }, payload) => {
  commit('ADD_FORMS_ANSWER', payload)
}
export const setFormsAnswerLoading = ({ commit }, payload) => {
  commit('SET_FORMS_ANSWER_LOADING', payload)
}

export const setQuestions = ({ commit }, payload) => {
  commit('SET_QUESTIONS', payload)
}
export const addQuestions = ({ commit }, payload) => {
  commit('ADD_QUESTIONS', payload)
}
export const setQuestionsLoading = ({ commit }, payload) => {
  commit('SET_QUESTIONS_LOADING', payload)
}

export const setFormClient = ({ commit }, payload) => {
  commit('SET_FORM_CLIENT', payload)
}
export const addFormClient = ({ commit }, payload) => {
  commit('ADD_FORM_CLIENT', payload)
}
export const setFormClientLoading = ({ commit }, payload) => {
  commit('SET_FORM_CLIENT_LOADING', payload)
}
export const setKitDocumentos = ({ commit }, payload) => {
  commit('SET_KIT_DOCUMENTOS', payload)
}
export const addKitDocumentos = ({ commit }, payload) => {
  commit('ADD_KIT_DOCUMENTOS', payload)
}
export const setKitDocumentosLoading = ({ commit }, payload) => {
  commit('SET_KIT_DOCUMENTOS_LOADING', payload)
}

export const setDataAppCliente = ({ commit }, payload) => {
  commit('SET_DATA_APP_CLIENTE', payload)
}
export const addDataAppCliente = ({ commit }, payload) => {
  commit('ADD_DATA_APP_CLIENTE', payload)
}
export const setDataAppClienteLoading = ({ commit }, payload) => {
  commit('SET_DATA_APP_CLIENTE_LOADING', payload)
}

export const setKycClassification = ({ commit }, payload) => {
  commit('SET_KYC_CLASSIFICATION', payload)
}
export const setKycClassificationLoading = ({ commit }, payload) => {
  commit('SET_KYC_CLASSIFICATION_LOADING', payload)
}

export const setPendenciasIpsKyc = ({ commit }, payload) => {
  commit('SET_PENDENCIAS_IPS_KYC', payload)
}

export const setPendenciasIpsKycLoading = ({ commit }, payload) => {
  commit('SET_PENDENCIAS_IPS_KYC_LOADING', payload)
}
